import React, {useEffect, useMemo, useReducer, useRef, useState} from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import {postUploadImage} from '../../../apis/image/postUploadImage'
import useNavigation from '../../../hooks/useNavigation'
import WizButton from '../../../components/button/WizButton'
import WizImage from '../../../components/image/WizImage'
import Text from '../../../components/text/Text'
import WizSelectButton from '../../../components/button/WizSelectButton'
import UnderLineInput from '../../../components/input/UnderLineInput'
import {useImage} from '../../../utils/image'
import useQueryLeaderboardBannerDetail from '../../../hooks/api/banner/useQueryLeaderboardBannerDetail'
import {useSearchParams} from 'react-router-dom'
import EditBannerConfirmModal from '../../../features/page/leaderboard/banner/EditBannerConfirmModal'
import {ReactComponent as IconNext} from '../../../assets/images/ic_btn_next.svg'

interface IProps {
    className?: string
}

const initState = {
    channel: 'ko',
    is_active: false,
    priority: 0,
    banner_image_pc: '',
    banner_image_mo: '',
    background: '#FFFFFF',
    subTitle: {
        type: 'text',
        image: '',
        text: '',
        color: '#FFFFFF',
    },
    title: {
        type: 'text',
        text: '',
        image_pc: '',
        image_mo: '',
        color: '#FFFFFF',
    },
    description: {
        text: '',
        color: '#FFFFFF',
    },
    button: {
        text: '',
        link: '',
        is_view: false,
        text_color: '#FFFFFF',
        border_color: '#FFFFFF',
        background_color: 'transparent',
        hover_background_color: 'transparent',
    },
    placement: ['leaderboard'],
    checkSubTitleBgColor: '#FFFFFF',
    checkContentBgColor: '#FFFFFF',
    switchPreview: 'pc',
}

const LeaderboardBannerDetailPage: React.FC<IProps> = ({className}) => {
    const {goBanner} = useNavigation()
    const {renderImage} = useImage()
    const [searchParams] = useSearchParams(document.location.search)
    const queryId = searchParams.get('id')
    const {data, refetch} = useQueryLeaderboardBannerDetail(queryId)

    const [isFocus, setIsFocus] = useState(false)
    const [state, dispatch] = useReducer(reducer, initState)

    const {
        name,
        channel,
        is_active,
        priority,
        banner_image_pc,
        banner_image_mo,
        background,
        subTitle,
        title,
        description,
        button,
        checkSubTitleBgColor,
        checkContentBgColor,
        switchPreview,
        placement,
    } = state

    function reducer(state, action) {
        switch (action.type) {
            case 'field_reset': {
                return {
                    ...state,
                    channel: data?.language,
                    is_active: data?.is_active,
                    priority: data?.priority,
                    banner_image_pc: data?.banner_image_pc,
                    banner_image_mo: data?.banner_image_mo,
                    background: data?.background,
                    subTitle: {
                        type: data?.sub_title?.image_url ? 'image' : 'text',
                        image: data?.sub_title?.image_url,
                        text: data?.sub_title?.text,
                        color: data?.sub_title?.color,
                    },
                    title: {
                        type: data?.content?.image_pc || data?.content?.image_mo ? 'image' : 'text',
                        image_pc: data?.content?.image_pc,
                        image_mo: data?.content?.image_mo,
                        text: data?.content?.title,
                        color: data?.content?.title_color,
                    },
                    description: {
                        text: data?.content?.desc,
                        color: data?.content?.desc_color,
                    },
                    button: {
                        text: data?.button?.text,
                        link: data?.button?.link,
                        is_view: data?.button?.view === 'view',
                        text_color: data?.button?.text_color,
                        border_color: data?.button?.border_color,
                        background_color: data?.button?.background_color,
                        hover_background_color: data?.button?.hover_background_color,
                    },
                    placement: data?.placement?.at(0) || 'leaderboard',
                }
            }
            case 'field_update':
                return {...state, [action.field]: action.value}
        }
        return {...state}
    }

    useEffect(() => {
        dispatch({type: 'field_reset'})
    }, [data])

    useEffect(() => {}, [state])

    const onChangeSubTitleImage = async e => {
        const imageFile = e?.target?.files[0]

        if (imageFile) {
            const result = await postUploadImage(imageFile)
            dispatch({
                type: 'field_update',
                field: 'subTitle',
                value: {
                    ...subTitle,
                    image: result?.image_url,
                },
            })
        }
    }

    const onChangeContentImagePc = async e => {
        const imageFile = e?.target?.files[0]

        if (imageFile) {
            const result = await postUploadImage(imageFile)
            dispatch({
                type: 'field_update',
                field: 'title',
                value: {
                    ...title,
                    image_pc: result?.image_url,
                },
            })
        }
    }

    const onChangeContentImageMo = async e => {
        const imageFile = e?.target?.files[0]

        if (imageFile) {
            const result = await postUploadImage(imageFile)
            dispatch({
                type: 'field_update',
                field: 'title',
                value: {
                    ...title,
                    image_mo: result?.image_url,
                },
            })
        }
    }

    const onChangeBanner = async (e, callback) => {
        const imageFile = e?.target?.files[0]

        if (imageFile) {
            const result = await postUploadImage(imageFile)
            callback(result?.image_url)
        }
    }

    const channelList = useMemo(
        () => [
            {id: 'ko', value: 'Korean'},
            {id: 'en', value: 'English'},
        ],
        [],
    )

    const activeList = useMemo(
        () => [
            {id: true, value: 'Active'},
            {id: false, value: 'Deactivation'},
        ],
        [],
    )

    const subTitleTypeList = useMemo(
        () => [
            {id: 'text', value: 'Text'},
            {id: 'image', value: 'Image'},
        ],
        [],
    )

    const titleTypeList = useMemo(
        () => [
            {id: 'text', value: 'Text'},
            {id: 'image', value: 'Image'},
        ],
        [],
    )

    const isViewList = useMemo(
        () => [
            {id: true, value: 'View'},
            {id: false, value: 'None View'},
        ],
        [],
    )

    const isPlacementList = useMemo(
        () => [
            {id: 'leaderboard', value: 'Leaderboard'},
            {id: 'tradermap', value: 'Tradermap'},
            {id: 'landing-banner', value: 'Landing Banner'},
        ],
        [],
    )

    const previewList = useMemo(
        () => [
            {id: 'pc', value: 'PC'},
            {id: 'laptop', value: 'Laptop'},
            {id: 'tablet', value: 'Tablet'},
            {id: 'mobile', value: 'Mobile'},
        ],
        [],
    )

    const switchSize = useMemo(() => {
        switch (switchPreview) {
            case 'pc':
                return 'h-[320px]'
            case 'laptop':
                return 'h-[320px] max-w-[1024px]'
            case 'tablet':
                return 'h-[320px] max-w-[720px]'
            case 'mobile':
                return 'h-[270px] max-w-[360px]'
        }
    }, [switchPreview])

    const bannerImagePcRef = useRef<any>()
    const bannerImageMoRef = useRef<any>()
    const subTitleImageRef = useRef<any>()
    const titleImagePcRef = useRef<any>()
    const titleImageMoRef = useRef<any>()
    const confirmModalRef = useRef<any>()
    const onClickCreateBanner = async () => {
        const body = {
            id: data?.id,
            name: name,
            language: channel,
            is_active: is_active,
            background: background,
            banner_image_pc: banner_image_pc,
            banner_image_mo: banner_image_mo,
            url: '',
            sub_title: {
                type: '',
                image_url: subTitle?.image,
                text: subTitle?.text,
                color: subTitle?.color,
            },
            content: {
                image_pc: title?.image_pc,
                image_mo: title?.image_mo,
                title: title?.text,
                desc: description?.text,
                title_color: title?.color,
                desc_color: description?.color,
            },
            button: {
                text: button?.text,
                link: button?.link,
                view: button?.is_view ? 'view' : 'hide',
                text_color: button?.text_color,
                border_color: button?.border_color,
                background_color: button?.background_color,
                hover_background_color: button?.hover_background_color,
            },
            placement: [placement],
            priority: Number(priority),
        }
        confirmModalRef?.current?.show(body)
    }
    return (
        <PageLayout title={'Edit Banner'}>
            <div className={'bg-white rounded-[10px] shadow-normal mx-auto py-[40px] px-[20px] md:px-[20px]'}>
                {/* channel and active */}
                <div
                    className={
                        'flex mt-[30px] gap-x-[40px] justify-center md:flex-col md:gap-y-[30px] md:justify-center md:items-center md:text-center'
                    }>
                    <div className={'space-y-[5px] sm:text-center'}>
                        <Text className={'text-body3 text-font02'}>Channel</Text>
                        <WizSelectButton
                            data={channelList}
                            onChange={e => {
                                dispatch({
                                    type: 'field_update',
                                    field: 'channel',
                                    value: channelList?.find(item => item.id === e.id).id,
                                })
                            }}
                            activeValue={channelList?.find(item => item.id === channel)}
                            className={'sm:mx-auto'}
                        />
                    </div>
                    <div className={'space-y-[5px] sm:text-center'}>
                        <Text className={'text-body3 text-font02'}>Active</Text>
                        <WizSelectButton
                            data={activeList}
                            onChange={e => {
                                dispatch({
                                    type: 'field_update',
                                    field: 'is_active',
                                    value: activeList?.find(item => item.id === e.id).id,
                                })
                            }}
                            activeValue={activeList?.find(item => item.id === is_active)}
                            className={'sm:mx-auto'}
                        />
                    </div>

                    {/* priority */}
                    <div className={'space-y-[5px] sm:text-center'}>
                        <Text className={'text-body3 text-font02'}>Priority</Text>
                        <UnderLineInput
                            value={priority}
                            placeholder={'0'}
                            className={'text-body1 max-w-[100px] flex-1'}
                            onChanged={text =>
                                dispatch({
                                    type: 'field_update',
                                    field: 'priority',
                                    value: text,
                                })
                            }
                        />
                    </div>
                </div>

                {/* banner image */}
                <div className={'mt-[60px] text-center'}>
                    <Text className={'text-h2 text-font02 pb-[5px]'}>Banner</Text>
                    <div>
                        <div className={'mt-[30px]'}>
                            <Text className={'text-body3 text-font02'}>Banner Image (PC)</Text>
                            <div className={'flex items-center gap-x-[10px] w-full mt-[10px] justify-center'}>
                                <div
                                    onClick={() => bannerImagePcRef?.current?.click()}
                                    style={{backgroundColor: background}}
                                    className={
                                        'ring-[1px] ring-line02 max-w-[720px] relative h-[320px] rounded-[5px] overflow-hidden cursor-pointer hover:border-primary flex-1'
                                    }>
                                    {banner_image_pc ? (
                                        <div
                                            dir={'rtl'}
                                            className={`flex sm:hidden flex-col w-[720px] sm:w-[100%] absolute top-0 right-0 h-[320px] sm:h-[270px]`}>
                                            <WizImage src={renderImage(banner_image_pc)} />
                                        </div>
                                    ) : (
                                        <Text className={'text-body_comm text-font04 text-center leading-[320px]'}>
                                            None Image
                                        </Text>
                                    )}
                                </div>
                                <input
                                    type={'file'}
                                    onChange={e => {
                                        onChangeBanner(e, value => {
                                            dispatch({
                                                type: 'field_update',
                                                field: 'banner_image_pc',
                                                value: value,
                                            })
                                        })
                                    }}
                                    ref={bannerImagePcRef}
                                    className={'hidden'}
                                />
                            </div>
                            <Text className={'mt-[5px] text-body3 text-font02 text-center'}>
                                * 화면이 720px보다 작을 경우 이미지가 깨질 수 있습니다
                            </Text>
                        </div>
                    </div>

                    <div>
                        <div className={'mt-[30px]'}>
                            <Text className={'text-body3 text-font02'}>Banner Image (Mo)</Text>
                            <div className={'flex items-center gap-x-[10px] w-full mt-[10px] justify-center'}>
                                <div
                                    onClick={() => bannerImageMoRef?.current?.click()}
                                    style={{backgroundColor: background}}
                                    className={
                                        'ring-[1px] ring-line02 max-w-[360px] h-[270px] relative rounded-[5px] overflow-hidden cursor-pointer hover:border-primary flex-1'
                                    }>
                                    {banner_image_mo ? (
                                        <>
                                            <div
                                                dir={'rtl'}
                                                className={`flex flex-col w-[100%] absolute top-0 right-0 h-[270px]`}>
                                                <WizImage
                                                    src={renderImage(banner_image_mo, 1920)}
                                                    className={'object-cover w-full h-[270px]'}
                                                    containerClassName={'max-w-[100%] w-full'}
                                                />
                                            </div>
                                        </>
                                    ) : (
                                        <Text className={'text-body_comm text-font04 text-center leading-[270px]'}>
                                            None Image
                                        </Text>
                                    )}
                                </div>
                                <input
                                    type={'file'}
                                    onChange={e => {
                                        onChangeBanner(e, value => {
                                            dispatch({
                                                type: 'field_update',
                                                field: 'banner_image_mo',
                                                value: value,
                                            })
                                        })
                                    }}
                                    ref={bannerImageMoRef}
                                    className={'hidden'}
                                />
                            </div>
                            <Text className={'mt-[5px] text-body3 text-font02 text-center'}>
                                * 화면이 360px보다 작을 경우 이미지가 깨질 수 있습니다
                            </Text>
                        </div>
                    </div>

                    <div className={'mt-[30px] flex gap-x-[20px] justify-center'}>
                        <div>
                            <Text className={'text-body3 text-font02'}>Background Color</Text>
                            <div className={'flex items-center gap-x-[10px] w-full mt-[10px]'}>
                                <UnderLineInput
                                    value={background}
                                    placeholder={'#FFFFFF'}
                                    className={'text-body1 max-w-[120px] flex-1'}
                                    onChanged={text =>
                                        dispatch({
                                            type: 'field_update',
                                            field: 'background',
                                            value: text,
                                        })
                                    }
                                />
                                <div
                                    style={{backgroundColor: background}}
                                    className={`w-[20px] h-[20px] border border-line01 rounded-[3px]`}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/* background color */}

                {/* sub title */}
                <div className={'mt-[60px] text-center'}>
                    <Text className={'text-h2 text-font02 pb-[5px]'}>SubTitle</Text>
                    <div className={'space-y-[5px] sm:text-center'}>
                        <Text className={'text-body3 text-font02'}>SubTitle Type</Text>
                        <div className={'flex items-center gap-x-[10px] justify-center relative w-min mx-auto'}>
                            <WizSelectButton
                                data={subTitleTypeList}
                                onChange={e => {
                                    dispatch({
                                        type: 'field_update',
                                        field: 'subTitle',
                                        value: {
                                            ...subTitle,
                                            type: subTitleTypeList?.find(item => item.id === e.id).id,
                                        },
                                    })
                                }}
                                activeValue={subTitleTypeList?.find(item => {
                                    if (item?.id === subTitle?.type) {
                                        return item?.id
                                    }
                                })}
                                className={'sm:mx-auto'}
                            />
                            {subTitle?.type === 'image' && (
                                <div
                                    className={
                                        'absolute top-[50%] translate-y-[-50%] translate-x-[100%] right-[-10px]'
                                    }>
                                    <div
                                        className={
                                            'border border-line01 rounded-full py-[5px] px-[10px] flex gap-x-[5px] w-min'
                                        }>
                                        <div
                                            onClick={() => {
                                                dispatch({
                                                    type: 'field_update',
                                                    field: 'checkSubTitleBgColor',
                                                    value: '#FFFFFF',
                                                })
                                            }}
                                            className={`w-[15px] h-[15px] rounded-full border-[2px] border-line02 cursor-pointer ${
                                                checkSubTitleBgColor === '#FFFFFF' && 'border-primary'
                                            }`}></div>
                                        <div
                                            onClick={() => {
                                                dispatch({
                                                    type: 'field_update',
                                                    field: 'checkSubTitleBgColor',
                                                    value: '#000000',
                                                })
                                            }}
                                            className={`w-[15px] h-[15px] rounded-full border-[2px] border-line02 bg-black cursor-pointer ${
                                                checkSubTitleBgColor === '#000000' && 'border-primary'
                                            }`}></div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    {subTitle?.type === 'image' ? (
                        <div className={'mt-[30px]'}>
                            <Text className={'text-body3 text-font02'}>SubTitle Image</Text>
                            <div className={'flex items-center gap-x-[10px] w-full mt-[10px] justify-center'}>
                                <div
                                    onClick={() => subTitleImageRef?.current?.click()}
                                    style={{backgroundColor: checkSubTitleBgColor}}
                                    className={
                                        'border border-line02 max-w-[500px] relative h-[60px] rounded-[5px] overflow-hidden cursor-pointer hover:border-primary flex-1'
                                    }>
                                    {subTitle?.image ? (
                                        <div className={'h-full flex flex-col justify-center items-center'}>
                                            <div className={'h-[26px] sm:h-[21px] w-full'}>
                                                <WizImage
                                                    src={renderImage(subTitle?.image)}
                                                    containerClassName={'h-full'}
                                                    className={'h-full mx-auto'}
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <Text className={'text-body_comm text-font04 text-center leading-[60px]'}>
                                            None Image
                                        </Text>
                                    )}
                                </div>
                                <input
                                    type={'file'}
                                    onChange={e => {
                                        onChangeSubTitleImage(e)
                                    }}
                                    ref={subTitleImageRef}
                                    className={'hidden'}
                                />
                            </div>
                        </div>
                    ) : (
                        <div className={'mt-[30px] flex gap-x-[20px] justify-center'}>
                            <div className={'w-full max-w-[350px]'}>
                                <Text className={'text-body3 text-font02'}>SubTitle Text</Text>
                                <div className={'flex items-center gap-x-[10px] w-full mt-[10px]'}>
                                    <UnderLineInput
                                        value={subTitle?.text}
                                        placeholder={'SubTitle'}
                                        className={'text-ti1 sm:text-ti2 max-w-[500px] flex-1'}
                                        onChanged={text =>
                                            dispatch({
                                                type: 'field_update',
                                                field: 'subTitle',
                                                value: {
                                                    ...subTitle,
                                                    text: text,
                                                },
                                            })
                                        }
                                    />
                                </div>
                            </div>
                            <div>
                                <Text className={'text-body3 text-font02'}>SubTitle Color</Text>
                                <div className={'flex items-center gap-x-[10px] w-full mt-[10px]'}>
                                    <UnderLineInput
                                        value={subTitle?.color}
                                        placeholder={'#FFFFFF'}
                                        className={'text-body1 max-w-[120px] flex-1'}
                                        onChanged={text =>
                                            dispatch({
                                                type: 'field_update',
                                                field: 'subTitle',
                                                value: {
                                                    ...subTitle,
                                                    color: text,
                                                },
                                            })
                                        }
                                    />
                                    <div
                                        style={{backgroundColor: subTitle?.color}}
                                        className={`w-[20px] h-[20px] border border-line01 rounded-[3px]`}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* title */}
                <div className={'mt-[60px] text-center'}>
                    <Text className={'text-h2 text-font02 pb-[5px]'}>Title</Text>
                    <div className={'space-y-[5px] sm:text-center'}>
                        <Text className={'text-body3 text-font02'}>Title Type</Text>
                        <div className={'flex gap-x-[10px] items-center justify-center relative w-min mx-auto'}>
                            <WizSelectButton
                                data={titleTypeList}
                                onChange={e => {
                                    dispatch({
                                        type: 'field_update',
                                        field: 'title',
                                        value: {
                                            ...title,
                                            type: titleTypeList?.find(item => item.id === e.id).id,
                                        },
                                    })
                                }}
                                activeValue={titleTypeList?.find(item => {
                                    if (item?.id === title?.type) {
                                        return item?.id
                                    }
                                })}
                                className={'sm:mx-auto'}
                            />
                            {title?.type === 'image' && (
                                <div
                                    className={
                                        'absolute top-[50%] translate-y-[-50%] translate-x-[100%] right-[-10px]'
                                    }>
                                    <div
                                        className={
                                            'border border-line01 rounded-full py-[5px] px-[10px] flex gap-x-[5px] w-min'
                                        }>
                                        <div
                                            onClick={() => {
                                                dispatch({
                                                    type: 'field_update',
                                                    field: 'checkContentBgColor',
                                                    value: '#FFFFFF',
                                                })
                                            }}
                                            className={`w-[15px] h-[15px] rounded-full border-[2px] border-line02 cursor-pointer ${
                                                checkContentBgColor === '#FFFFFF' && 'border-primary'
                                            }`}></div>
                                        <div
                                            onClick={() => {
                                                dispatch({
                                                    type: 'field_update',
                                                    field: 'checkContentBgColor',
                                                    value: '#000000',
                                                })
                                            }}
                                            className={`w-[15px] h-[15px] rounded-full border-[2px] border-line02 bg-black cursor-pointer ${
                                                checkContentBgColor === '#000000' && 'border-primary'
                                            }`}></div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    {title?.type === 'image' ? (
                        <div className={'mt-[30px]'}>
                            <Text className={'text-body3 text-font02'}>Title Image (PC)</Text>
                            <div className={'flex items-center gap-x-[10px] w-full mt-[10px] justify-center'}>
                                <div
                                    onClick={() => titleImagePcRef?.current?.click()}
                                    style={{backgroundColor: checkContentBgColor}}
                                    className={
                                        'border border-line02 max-w-[650px] relative min-h-[80px] rounded-[5px] overflow-hidden cursor-pointer hover:border-primary flex-1'
                                    }>
                                    {title?.image_pc ? (
                                        <WizImage
                                            src={renderImage(title?.image_pc)}
                                            containerClassName={'flex items-center justify-center h-full'}
                                        />
                                    ) : (
                                        <Text className={'text-body_comm text-font04 text-center leading-[80px]'}>
                                            None Image
                                        </Text>
                                    )}
                                </div>
                                <input
                                    type={'file'}
                                    onChange={e => {
                                        onChangeContentImagePc(e)
                                    }}
                                    ref={titleImagePcRef}
                                    className={'hidden'}
                                />
                            </div>

                            <Text className={'text-body3 text-font02 mt-[20px]'}>Title Image (Mo)</Text>
                            <div className={'flex items-center gap-x-[10px] w-full mt-[10px] justify-center'}>
                                <div
                                    onClick={() => titleImageMoRef?.current?.click()}
                                    style={{backgroundColor: checkContentBgColor}}
                                    className={
                                        'border border-line02 max-w-[650px] relative min-h-[80px] rounded-[5px] overflow-hidden cursor-pointer hover:border-primary flex-1'
                                    }>
                                    {title?.image_mo ? (
                                        <WizImage
                                            src={renderImage(title?.image_mo)}
                                            containerClassName={'flex items-center justify-center h-full'}
                                        />
                                    ) : (
                                        <Text className={'text-body_comm text-font04 text-center leading-[80px]'}>
                                            None Image
                                        </Text>
                                    )}
                                </div>
                                <input
                                    type={'file'}
                                    onChange={e => {
                                        onChangeContentImageMo(e)
                                    }}
                                    ref={titleImageMoRef}
                                    className={'hidden'}
                                />
                            </div>

                            <Text className={'text-body3 text-font02 mt-[20px]'}>Image alt</Text>
                            <div className={'flex items-center gap-x-[10px] w-full mt-[10px] justify-center'}>
                                <UnderLineInput
                                    value={title?.text}
                                    placeholder={'alt text'}
                                    className={'text-ti1 sm:text-ti2 max-w-[500px] flex-1'}
                                    onChanged={text =>
                                        dispatch({
                                            type: 'field_update',
                                            field: 'title',
                                            value: {
                                                ...title,
                                                text: text,
                                            },
                                        })
                                    }
                                />
                            </div>
                        </div>
                    ) : (
                        <div className={'mt-[30px] flex gap-x-[20px] justify-center'}>
                            <div className={'w-full max-w-[350px]'}>
                                <Text className={'text-body3 text-font02'}>Title Text</Text>
                                <div className={'flex items-center gap-x-[10px] w-full mt-[10px] justify-center'}>
                                    <UnderLineInput
                                        value={title?.text}
                                        placeholder={'Title'}
                                        className={'text-ti1 sm:text-ti2 max-w-[500px] flex-1'}
                                        onChanged={text =>
                                            dispatch({
                                                type: 'field_update',
                                                field: 'title',
                                                value: {
                                                    ...title,
                                                    text: text,
                                                },
                                            })
                                        }
                                    />
                                </div>
                            </div>
                            <div>
                                <Text className={'text-body3 text-font02'}>Title Color</Text>
                                <div className={'flex items-center gap-x-[10px] w-full mt-[10px] justify-center'}>
                                    <UnderLineInput
                                        value={title?.color}
                                        placeholder={'#FFFFFF'}
                                        className={'text-body1 max-w-[120px] flex-1'}
                                        onChanged={text =>
                                            dispatch({
                                                type: 'field_update',
                                                field: 'title',
                                                value: {
                                                    ...title,
                                                    color: text,
                                                },
                                            })
                                        }
                                    />
                                    <div
                                        style={{backgroundColor: title?.color}}
                                        className={`w-[20px] h-[20px] border border-line01 rounded-[3px]`}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <div className={'mt-[60px] text-center'}>
                    <Text className={'text-h2 text-font02 pb-[5px]'}>Description</Text>
                    <div className={'flex gap-x-[20px] justify-center'}>
                        <div className={'w-full max-w-[350px]'}>
                            <Text className={'text-body3 text-font02'}>Description Text</Text>
                            <div className={'flex items-center gap-x-[10px] w-full mt-[10px]'}>
                                <UnderLineInput
                                    value={description?.text}
                                    placeholder={'Description'}
                                    className={'text-ti1 sm:text-ti2 max-w-[500px] flex-1'}
                                    onChanged={text =>
                                        dispatch({
                                            type: 'field_update',
                                            field: 'description',
                                            value: {
                                                ...description,
                                                text: text,
                                            },
                                        })
                                    }
                                />
                            </div>
                        </div>
                        <div>
                            <Text className={'text-body3 text-font02'}>Description Color</Text>
                            <div className={'flex items-center gap-x-[10px] w-full mt-[10px]'}>
                                <UnderLineInput
                                    value={description?.color}
                                    placeholder={'#FFFFFF'}
                                    className={'text-body1 max-w-[120px] flex-1'}
                                    onChanged={text =>
                                        dispatch({
                                            type: 'field_update',
                                            field: 'description',
                                            value: {
                                                ...description,
                                                color: text,
                                            },
                                        })
                                    }
                                />
                                <div
                                    style={{backgroundColor: description?.color}}
                                    className={`w-[20px] h-[20px] border border-line01 rounded-[3px]`}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className={'mt-[60px] text-center'}>
                    <Text className={'text-h2 text-font02 pb-[5px]'}>Button</Text>
                    <div>
                        <Text className={'text-body3 text-font02 pb-[3px]'}>Is View</Text>
                        <WizSelectButton
                            data={isViewList}
                            onChange={e => {
                                dispatch({
                                    type: 'field_update',
                                    field: 'button',
                                    value: {
                                        ...button,
                                        is_view: isViewList?.find(item => item.id === e.id).id,
                                    },
                                })
                            }}
                            activeValue={isViewList?.find(item => item?.id === button?.is_view)}
                            className={'mx-auto'}
                        />
                    </div>
                    {button?.is_view && (
                        <div className={'mt-[20px]'}>
                            <div className={'flex gap-x-[20px] justify-center'}>
                                <div className={'w-full max-w-[350px]'}>
                                    <Text className={'text-body3 text-font02'}>Button Text</Text>
                                    <div className={'flex items-center gap-x-[10px] w-full mt-[10px]'}>
                                        <UnderLineInput
                                            value={button?.text}
                                            placeholder={'Button Text'}
                                            className={'text-ti1 sm:text-ti2 max-w-[350px] flex-1'}
                                            onChanged={text =>
                                                dispatch({
                                                    type: 'field_update',
                                                    field: 'button',
                                                    value: {
                                                        ...button,
                                                        text: text,
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                </div>

                                <div className={'w-full max-w-[350px]'}>
                                    <Text className={'text-body3 text-font02'}>Button Link</Text>
                                    <div className={'flex items-center gap-x-[10px] w-full mt-[10px]'}>
                                        <UnderLineInput
                                            value={button?.link}
                                            placeholder={'Button Link'}
                                            className={'text-body1 max-w-[350px] flex-1'}
                                            onChanged={text =>
                                                dispatch({
                                                    type: 'field_update',
                                                    field: 'button',
                                                    value: {
                                                        ...button,
                                                        link: text,
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={'flex gap-x-[15px] mt-[20px] justify-center'}>
                                <div>
                                    <Text className={'text-body3 text-font02'}>Text Color</Text>
                                    <div className={'flex items-center gap-x-[10px] w-full mt-[10px]'}>
                                        <UnderLineInput
                                            value={button?.text_color}
                                            placeholder={'#FFFFFF'}
                                            className={'text-body1 max-w-[120px] flex-1'}
                                            onChanged={text =>
                                                dispatch({
                                                    type: 'field_update',
                                                    field: 'button',
                                                    value: {
                                                        ...button,
                                                        text_color: text,
                                                    },
                                                })
                                            }
                                        />
                                        <div
                                            style={{backgroundColor: button?.text_color}}
                                            className={`w-[20px] h-[20px] border border-line01 rounded-[3px]`}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <Text className={'text-body3 text-font02'}>Border Color</Text>
                                    <div className={'flex items-center gap-x-[10px] w-full mt-[10px]'}>
                                        <UnderLineInput
                                            value={button?.border_color}
                                            placeholder={'#FFFFFF'}
                                            className={'text-body1 max-w-[120px] flex-1'}
                                            onChanged={text =>
                                                dispatch({
                                                    type: 'field_update',
                                                    field: 'button',
                                                    value: {
                                                        ...button,
                                                        border_color: text,
                                                    },
                                                })
                                            }
                                        />
                                        <div
                                            style={{backgroundColor: button?.border_color}}
                                            className={`w-[20px] h-[20px] border border-line01 rounded-[3px]`}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <Text className={'text-body3 text-font02'}>Background Color</Text>
                                    <div className={'flex items-center gap-x-[10px] w-full mt-[10px]'}>
                                        <UnderLineInput
                                            value={button?.background_color}
                                            placeholder={'Transparent'}
                                            className={'text-body1 max-w-[120px] flex-1'}
                                            onChanged={text =>
                                                dispatch({
                                                    type: 'field_update',
                                                    field: 'button',
                                                    value: {
                                                        ...button,
                                                        background_color: text,
                                                    },
                                                })
                                            }
                                        />
                                        <div
                                            style={{backgroundColor: button?.background_color}}
                                            className={`w-[20px] h-[20px] border border-line01 rounded-[3px]`}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <Text className={'text-body3 text-font02'}>HoverBackground Color</Text>
                                    <div className={'flex items-center gap-x-[10px] w-full mt-[10px]'}>
                                        <UnderLineInput
                                            value={button?.hover_background_color}
                                            placeholder={'Transparent'}
                                            className={'text-body1 max-w-[120px] flex-1'}
                                            onChanged={text =>
                                                dispatch({
                                                    type: 'field_update',
                                                    field: 'button',
                                                    value: {
                                                        ...button,
                                                        hover_background_color: text,
                                                    },
                                                })
                                            }
                                        />
                                        <div
                                            style={{backgroundColor: button?.hover_background_color}}
                                            className={`w-[20px] h-[20px] border border-line01 rounded-[3px]`}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <Text className={'mt-[60px] text-h2 text-font02 pb-[5px] text-center'}>Placement</Text>
                <div>
                    <WizSelectButton
                        data={isPlacementList}
                        onChange={e => {
                            dispatch({
                                type: 'field_update',
                                field: 'placement',
                                value: isPlacementList?.find(item => item.id === e.id).id,
                            })
                        }}
                        activeValue={isPlacementList?.find(item => item?.id === placement)}
                        className={'mx-auto'}
                    />
                </div>
            </div>

            <Text className={'text-ti1 text-font02 mt-[60px] pb-[5px] text-center'}>Preview</Text>
            <WizSelectButton
                data={previewList}
                onChange={e => {
                    dispatch({
                        type: 'field_update',
                        field: 'switchPreview',
                        value: previewList?.find(item => item.id === e.id).id,
                    })
                }}
                activeValue={previewList?.find(item => item?.id === switchPreview)}
                className={'mx-auto'}
            />
            <div
                style={{backgroundColor: background}}
                className={`w-full relative overflow-hidden ${switchPreview === 'mobile' ? 'h-[270px]' : 'h-[320px]'}
             mx-auto mt-[10px] rounded-[5px]  ${switchSize}`}>
                <a href={button?.link} target={'_blank'} rel="noreferrer" className={'max-w-[1366px] mx-auto block'}>
                    <div className={'relative h-full'}>
                        {switchPreview === 'mobile' && (
                            <div
                                dir={'rtl'}
                                className={`absolute right-0 top-0 sm:right-auto sm:left-[50%] sm:translate-x-[-50%] sm:w-full`}>
                                <WizImage
                                    src={renderImage(banner_image_mo, 1920)}
                                    className={'object-cover w-full h-[270px]'}
                                    containerClassName={'max-w-[100%] w-full'}
                                />
                            </div>
                        )}
                        {switchPreview !== 'mobile' && (
                            <div
                                dir={'rtl'}
                                className={`absolute right-0 top-0 sm:right-auto sm:left-[50%] sm:translate-x-[-50%] sm:w-full h-[320px]`}>
                                <WizImage
                                    src={renderImage(banner_image_pc)}
                                    containerClassName={'max-w-[100%] h-full'}
                                    className={'h-full'}
                                />
                            </div>
                        )}
                        <div
                            className={`flex-1 flex flex-col px-[20px] relative z-[10] ${
                                switchPreview === 'mobile' ? 'pt-[73px]' : 'pt-[75px]'
                            }`}>
                            <div className={'flex-1 flex flex-col justify-center'}>
                                {subTitle?.image ? (
                                    <div
                                        className={`${
                                            switchPreview === 'mobile' ? 'h-[21px]' : 'h-[36px]'
                                        } flex flex-col justify-center`}>
                                        <div
                                            className={`${
                                                switchPreview === 'mobile'
                                                    ? 'h-[21px] bg-[length:auto_21px]'
                                                    : 'h-[26px] bg-[length:auto_26px]'
                                            } w-full bg-no-repeat `}
                                            style={{
                                                backgroundImage: `url(${renderImage(subTitle?.image, 720)})`,
                                            }}
                                        />
                                    </div>
                                ) : subTitle?.text ? (
                                    <Text
                                        inlineStyle={{color: subTitle?.color || '#FFFFFF'}}
                                        className={` ${
                                            subTitle?.text?.length >= 26 && 'md:text-[2.3vw] md:leading-[3.5vw]'
                                        } ${switchPreview === 'mobile' ? 'text-ti2' : 'text-h2'}`}>
                                        {subTitle?.text}
                                    </Text>
                                ) : (
                                    <></>
                                )}
                                {title?.image_pc || title?.image_mo ? (
                                    <>
                                        <div
                                            className={`${
                                                switchPreview === 'mobile' ? 'h-[120px]' : 'h-[154px]'
                                            } w-full`}>
                                            {switchPreview === 'mobile' ? (
                                                <WizImage
                                                    src={renderImage(title?.image_mo, 320)}
                                                    alt={`${title?.text} ${description?.text}`}
                                                    containerClassName={'max-h-[120px] max-w-[320px]'}
                                                />
                                            ) : (
                                                <WizImage
                                                    src={renderImage(title?.image_pc, 480)}
                                                    alt={`${title?.text} ${description?.text}`}
                                                    containerClassName={'max-h-[154px] max-w-[480px]'}
                                                />
                                            )}
                                        </div>
                                    </>
                                ) : (
                                    <Text
                                        inlineStyle={{color: title?.color || '#FFFFFF'}}
                                        className={`${
                                            switchPreview === 'mobile'
                                                ? 'text-h3'
                                                : switchPreview === 'tablet'
                                                ? 'text-[30px] leading-[40px]'
                                                : 'text-h1'
                                        } antialiased font-sans text-white  break-all ${
                                            title?.text?.length >= 26 && 'md:text-[3.9vw] md:leading-[5.25vw]'
                                        } font-bold`}>
                                        {title?.text}
                                    </Text>
                                )}
                                {description?.text && (
                                    <Text
                                        inlineStyle={{color: description?.color || '#FFFFFF'}}
                                        className={`${
                                            switchPreview === 'mobile' ? 'text-body3 mt-[5px]' : 'text-body1 mt-[10px] '
                                        } break-all`}>
                                        {description?.text}
                                    </Text>
                                )}
                                <div className={'flex items-center'}>
                                    {button?.is_view && (
                                        <div>
                                            <WizButton
                                                inlineStyle={{
                                                    borderColor: button?.border_color,
                                                    backgroundColor: isFocus
                                                        ? button?.hover_background_color || 'transparent'
                                                        : button?.background_color || 'transparent',
                                                }}
                                                inlineTextStyle={{color: button?.text_color}}
                                                text={button?.text}
                                                onMouseEnter={() => setIsFocus(true)}
                                                onMouseLeave={() => setIsFocus(false)}
                                                size={'medium'}
                                                className={`${
                                                    title?.type === 'image'
                                                        ? 'mt-0'
                                                        : `${switchPreview === 'mobile' ? 'mt-[20px]' : 'mt-[30px]'}`
                                                } bg-transparent border hover:bg-transparent py-[12px] px-[20px] ${
                                                    switchPreview === 'mobile' && 'hidden'
                                                }`}
                                                textClassName={'text-btn'}
                                            />

                                            <div
                                                className={`${
                                                    switchPreview === 'mobile' ? 'flex' : 'hidden'
                                                } items-center mt-[20px] cursor-pointer`}>
                                                <Text
                                                    inlineStyle={{color: data?.button?.text_color}}
                                                    className={'text-body2'}>
                                                    {data?.button?.text}
                                                </Text>
                                                <IconNext
                                                    style={{fill: data?.button?.text_color}}
                                                    className={`w-[12px]`}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
            <Text className={'mt-[10px] text-body3 text-font02 text-center'}>
                Preview Width :{' '}
                {switchPreview === 'pc'
                    ? '1440px(min)'
                    : switchPreview === 'laptop'
                    ? '1024px'
                    : switchPreview === 'tablet'
                    ? '720px'
                    : '360px'}
            </Text>
            <Text className={'mt-[5px] text-body3 text-font02 text-center'}>
                * Preview 화면보다 브라우저 크기가 작을 경우 이미지가 깨질 수 있습니다
            </Text>
            <div className={'col-span-2 text-center mt-[30px]'}>
                <WizButton type={'blue'} size={'big'} text={'Edit Banner'} onClick={() => onClickCreateBanner()} />
            </div>
            <EditBannerConfirmModal ref={confirmModalRef} />
        </PageLayout>
    )
}

export default LeaderboardBannerDetailPage
